/* GROCERY account pages (Oct 2026): sections/main-account.liquid and the
   sign-in / Join GRO+ doors (snippets/gro-account-doors.liquid).

   1. GRO+ points. Smile's storefront SDK (window.Smile, loaded by the Smile app
      embed) holds the signed-in customer's balance. We read it once the SDK says
      it's ready ('smile-js-initialized'), or straight away if it already is.
      No balance within a few seconds (SDK switched off in Smile admin, a slow
      network): the block keeps its size and the button reads "See your points",
      which opens the Smile panel.
   2. Stay in touch (Contact B): the WhatsApp card, the email Subscribe button and
      the message-language switch in Details.
   3. Reset password: if the recover form came back with an error, show it. */
(() => {
  /* ---------- GRO+ points ---------- */

  const box = document.querySelector('[data-gro-points]');

  if (box) {
    const step = parseInt(box.dataset.step, 10) || 1000;
    const value = box.dataset.value || '';
    const el = (name) => box.querySelector(`[data-gro-points-${name}]`);
    const fmt = (n) => Number(n).toLocaleString('en-US');
    let done = false;

    const show = (balance) => {
      if (done) return;
      done = true;
      const ready = Math.floor(balance / step);
      const toNext = step - (balance % step);
      el('num').textContent = fmt(balance);
      el('ready').textContent = ready > 0 ? box.dataset.ready.replace('%VALUE%', readyValue(ready)) : '';
      el('next').textContent = (ready > 0 ? box.dataset.next : box.dataset.first)
        .replace('%POINTS%', fmt(toNext))
        .replace('%VALUE%', value);
      el('bar').style.width = `${((balance % step) / step) * 100}%`;
      box.classList.add('is-loaded');
    };

    // "HK$40" → "HK$80" for two rewards: swap the number inside the formatted value.
    const readyValue = (count) => value.replace(/[\d.,]+/, (num) => fmt(parseFloat(num.replace(/,/g, '')) * count));

    const giveUp = () => {
      if (done) return;
      done = true;
      box.classList.add('is-fallback');
      box.querySelectorAll('[data-gro-points-cta]').forEach((span, i) => {
        span.hidden = i === 0;
      });
    };

    const balanceOf = (wallet) => {
      if (!wallet) return null;
      for (const key of ['points_balance', 'pointsBalance', 'balance']) {
        if (typeof wallet[key] === 'number') return wallet[key];
      }
      return null;
    };

    const read = async () => {
      const wallet = window.Smile && window.Smile.customerPointsWallet;
      if (!wallet || done) return false;
      try {
        let data = null;
        try {
          data = typeof wallet.preloaded === 'function' ? wallet.preloaded() : null;
        } catch (e) {}
        if (balanceOf(data) === null) data = await wallet.get();
        const balance = balanceOf(data);
        if (balance === null) return false;
        show(balance);
        return true;
      } catch (e) {
        return false;
      }
    };

    document.addEventListener('smile-js-initialized', read);
    read();
    setTimeout(() => read().then((ok) => ok || giveUp()), 6000);

    // Redeem: open Smile's "Ways to redeem" in place when the panel API is there;
    // otherwise the #smile-points-products link does it on its own.
    const redeem = el('redeem');
    redeem.addEventListener('click', (event) => {
      const ui = window.SmileUI;
      if (ui && typeof ui.openPanel === 'function') {
        event.preventDefault();
        try {
          ui.openPanel({ deep_link: 'points_products' });
        } catch (e) {
          window.location.hash = 'smile-points-products';
        }
      }
    });
  }

  /* ---------- stay in touch: WhatsApp card, email, message language ----------
     Consent goes to Klaviyo from the browser (client API, public key), exactly as
     the newsletter pop-up does, with the account email so it lands on the right
     profile; custom_source tells these apart in Klaviyo. The wishlist app then
     records it on the customer (/apps/wishlist/contact → metafield gro.contact),
     so the card stays gone on every device. If that record fails the consent still
     stands; the card would only come back on the next visit. */

  const configEl = document.getElementById('GroContactConfig');

  if (configEl) {
    let cfg = {};
    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (e) {}
    const str = cfg.strings || {};

    const store = {
      get: (key) => {
        try {
          return localStorage.getItem(key);
        } catch (e) {
          return null;
        }
      },
      set: (key, value) => {
        try {
          localStorage.setItem(key, value);
        } catch (e) {}
      },
      remove: (key) => {
        try {
          localStorage.removeItem(key);
        } catch (e) {}
      },
    };

    const klaviyo = (path, data) =>
      fetch(`https://a.klaviyo.com/client/${path}/?company_id=${encodeURIComponent(cfg.company)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
        body: JSON.stringify({ data }),
      }).then((res) => {
        if (!res.ok) throw new Error(`klaviyo ${res.status}`);
      });

    const subscribe = (attributes) =>
      klaviyo('subscriptions', {
        type: 'subscription',
        attributes: { custom_source: 'Account page', profile: { data: { type: 'profile', attributes } } },
        relationships: { list: { data: { type: 'list', id: cfg.list } } },
      });

    const record = (body) =>
      fetch(cfg.proxy, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then((res) => res.json())
        .catch(() => null);

    const savedLang = () => {
      const on = document.querySelector('[data-gro-lang][aria-pressed="true"]');
      return on ? on.dataset.groLang : null;
    };

    const onLabel = (text) => {
      const span = document.createElement('span');
      span.className = 'gro-acct-prefs__on';
      const mark = document.createElement('span');
      mark.className = 'gro-acct__mark';
      mark.setAttribute('aria-hidden', 'true');
      span.append(mark, document.createTextNode(text));
      return span;
    };

    /* WhatsApp card */
    const card = document.querySelector('[data-gro-wa-card]');
    const waStatus = document.querySelector('[data-gro-wa-status]');

    if (card) {
      const cc = card.querySelector('[data-gro-wa-cc]');
      const phone = card.querySelector('[data-gro-wa-phone]');
      const consent = card.querySelector('[data-gro-wa-consent]');
      const submit = card.querySelector('[data-gro-wa-submit]');
      const note = card.querySelector('[data-gro-wa-note]');
      const say = (text, ok) => {
        note.textContent = text;
        note.classList.toggle('is-ok', !!ok);
      };

      // Fill in the number we already have (customer or address phone).
      const hint = (phone.dataset.hint || '').replace(/[^\d+]/g, '');
      if (hint) {
        const match = [...cc.options].map((o) => o.value).sort((a, b) => b.length - a.length).find((code) => hint.startsWith(code));
        if (match) {
          cc.value = match;
          phone.value = hint.slice(match.length);
        } else if (!hint.startsWith('+')) {
          phone.value = hint;
        }
      }

      card.addEventListener('submit', async (event) => {
        event.preventDefault();
        const digits = phone.value.replace(/\D/g, '');
        const code = cc.value;
        const okLength = code === '+852' || code === '+853' ? digits.length === 8 : digits.length >= 6 && digits.length <= 12;
        if (!okLength) {
          say(str.errPhone);
          phone.setAttribute('aria-invalid', 'true');
          phone.focus();
          return;
        }
        phone.removeAttribute('aria-invalid');
        if (!consent.checked) {
          say(str.errConsent);
          consent.focus();
          return;
        }
        const number = code + digits;
        const attributes = {
          email: cfg.email,
          phone_number: number,
          subscriptions: { whatsapp: { marketing: { consent: 'SUBSCRIBED' } } },
        };
        const lang = savedLang();
        if (lang) attributes.properties = { Language: lang };

        submit.disabled = true;
        say(str.saving, true);
        try {
          await subscribe(attributes);
        } catch (e) {
          say(str.error);
          submit.disabled = false;
          return;
        }
        await record({ whatsapp: number });
        store.remove('gro:acct-wa-dismissed');
        say(str.done, true);
        if (waStatus) waStatus.replaceChildren(onLabel(`••••${number.slice(-4)}`));
        card.classList.add('is-done');
        setTimeout(() => {
          card.hidden = true;
        }, 2400);
      });

      card.querySelector('[data-gro-wa-dismiss]').addEventListener('click', () => {
        store.set('gro:acct-wa-dismissed', String(Date.now()));
        card.hidden = true;
      });

      const add = document.querySelector('[data-gro-wa-add]');
      if (add) {
        add.addEventListener('click', () => {
          store.remove('gro:acct-wa-dismissed');
          card.hidden = false;
          card.scrollIntoView({ block: 'center', behavior: 'smooth' });
          phone.focus({ preventScroll: true });
        });
      }
    }

    /* Email: subscribe (Klaviyo sends its confirmation email first) */
    const emailButton = document.querySelector('[data-gro-email-sub]');
    if (emailButton) {
      const cell = emailButton.parentElement;
      const pending = Number(store.get('gro:acct-email-requested'));
      if (pending && Date.now() - pending < 14 * 864e5) {
        cell.replaceChildren(document.createTextNode(str.checkInbox));
      } else {
        emailButton.addEventListener('click', async () => {
          emailButton.disabled = true;
          const attributes = { email: cfg.email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
          const lang = savedLang();
          if (lang) attributes.properties = { Language: lang };
          try {
            await subscribe(attributes);
            store.set('gro:acct-email-requested', String(Date.now()));
            cell.replaceChildren(document.createTextNode(str.checkInbox));
          } catch (e) {
            emailButton.disabled = false;
          }
        });
      }
    }

    /* Message language: Klaviyo profile property "Language" (EN | TC), which the
       flows split on, and the same value on the customer record. */
    document.querySelectorAll('[data-gro-lang]').forEach((button) => {
      button.addEventListener('click', async () => {
        const lang = button.dataset.groLang;
        if (button.getAttribute('aria-pressed') === 'true') return;
        const buttons = document.querySelectorAll('[data-gro-lang]');
        const before = savedLang();
        buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        try {
          await klaviyo('profiles', { type: 'profile', attributes: { email: cfg.email, properties: { Language: lang } } });
          await record({ lang });
        } catch (e) {
          buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.groLang === before)));
        }
      });
    });
  }

  /* ---------- reset password ---------- */

  if (document.querySelector('[data-gro-recover-error]') && window.location.hash !== '#recover') {
    window.location.hash = 'recover';
  }
})();
